import { getCookie, v as bvVar } from 'bv';

const getCurrencyCode = () => getCookie('currency_iso_code') || bvVar('currencyCode');

export default getCurrencyCode;
